import { IonAlert } from '@ionic/react';
import React from 'react';
import type { AlertProps } from './types';

import './Alert.scss';

const Alert: React.FC<AlertProps> = ({
  isOpen,
  header,
  message,
  buttons = ['Ok'],
  inputs,
  onDidDismiss,
}) => {
  return (
    <IonAlert
      mode="ios"
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
      header={header}
      message={message}
      buttons={buttons}
      inputs={inputs}
      backdropDismiss={false}
      cssClass="custom-alert"
    />
  );
};

export default React.memo(Alert);
